// min-h-screen prevents the page collapsing to 0 height while the chunk downloads,
// which would cause a CLS spike on client-side navigation.
export const PageFallback = () => <div className="min-h-screen" />;

// Dedicated skeleton for blog pages: reserves the right amount of space so that
// when React renders the actual blog post (using pre-rendered initialData), there
// is no visible layout shift. Used for client-side navigations where there is no
// pre-rendered HTML in #root.
export const BlogSkeleton = () => (
  <div className="min-h-screen flex flex-col">
    <div className="h-16 border-b bg-background shrink-0" />
    <div className="flex-1 max-w-4xl mx-auto w-full px-4 py-8">
      <div className="h-6 w-28 bg-muted animate-pulse rounded mb-6" />
      <div className="flex gap-2 mb-4">
        <div className="h-5 w-16 bg-muted animate-pulse rounded-full" />
        <div className="h-5 w-20 bg-muted animate-pulse rounded-full" />
      </div>
      <div className="h-10 w-3/4 bg-muted animate-pulse rounded mb-3" />
      <div className="h-6 w-1/2 bg-muted animate-pulse rounded mb-2" />
      <div className="h-4 w-32 bg-muted animate-pulse rounded mb-8" />
      <div className="aspect-square w-full bg-muted animate-pulse rounded-xl mb-8" />
      <div className="space-y-3">
        <div className="h-4 w-full bg-muted animate-pulse rounded" />
        <div className="h-4 w-full bg-muted animate-pulse rounded" />
        <div className="h-4 w-3/4 bg-muted animate-pulse rounded" />
      </div>
    </div>
  </div>
);
